// core
import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subscription } from "rxjs";
import { startWith , distinctUntilChanged } from 'rxjs/operators';

// Raptor
import { RaptorPredicateService } from '../../services/raptor-predicate.service';
import { RaptorControlService } from '../../services/raptor-control.service';
import { RaptorStepService } from '../../services/raptor-step.service';

@Component({
  selector: 'open-raptor-payment',
  templateUrl: './raptor-payment.component.html',
  styleUrls: ['./raptor-payment.component.scss']
})
export class RaptorPaymentComponent implements OnInit {
  @Input() question!: any;
  @Input() form!: FormGroup;
  @Input() submitted!: Boolean;

  sectionClass: string = '';
  heroType: string = '';
  paymentType: any;
  paymentOptions: Array<any> = [];
  paymentForm: any;
  showQuestion = true;
  questionControl: any;
  formValueWatcher!: Subscription;

  constructor(
    private raptorPredicateService: RaptorPredicateService,
    private raptorControlService: RaptorControlService,
    private raptorStepService: RaptorStepService
  ) { }

  ngOnInit(): void {

    if (this.question) {
      this.questionControl = this.form.get(this.question.key);
      this.checkShowIf();

      this.formValueWatcher = this.form.valueChanges
        .pipe(
          startWith(this.form.value),
          distinctUntilChanged((previous, current) => {
            return !this.raptorControlService.formValueChanged(previous, current);
          })
        )
        .subscribe(data => {
          this.checkShowIf();
        });
    }
  
    if (this.question.settings.payment_options && this.question.settings.payment_options.length) {
      if (this.question.settings.payment_options.length > 1) {
        this.paymentOptions = this.question.settings.payment_options;
      }
      if (!this.question?.const_is_staff) {
        this.paymentForm = this.question.settings.payment_options[0];
        this.paymentType = this.paymentForm.service;
      }
    }
  }

  checkShowIf(): void {
    if (this.question.show_if && typeof this.question.show_if === 'object') {
      this.showQuestion = this.raptorPredicateService.validator(this.question.show_if, this.form.value);
    }
  }

  optionChange(event: any) {
    this.raptorStepService.submitted = false;
    this.form.markAsPristine();
    this.raptorControlService.removePaymentValidators(this.questionControl);
    this.questionControl.get('selected_payment_option').setValue(event.value.service);
  }
}
